import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StatusComponent } from "./status.component";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
  declarations: [StatusComponent],
  imports: [CommonModule, FontAwesomeModule],
  exports: [StatusComponent],
})
export class StatusModule {}
